import getApiHeader from "../utils/getApiHeader";
import api from "../utils/api";

export const multiBindConsents = async (email, countryId, consentNos) => {
  if (consentNos.length > 0) {
    const headers = await getApiHeader();
    const consents = consentNos.map(no => ({
      code: no,
      language: headers.language,
      orgId: headers.organization,
      countryId
    }));
    const body = {
      email: email,
      consents
    };
    const { obj } = await api.consent.bind(null, body, {
      headers
    });
    //have newletter,parameter laster,contractId laster,no newsletter, laster,
    const length = obj ? obj.length - 1 : -1;
    const contractId = length > -1 ? obj[length].contractId : "";
    return contractId;
  } else {
    return null;
  }
};
